import { get, set } from 'lodash';

import { EXPENSE_PROPERTY_RELATED_EXPENSES } from '@funnels/constants';
import { Expenses } from '@funnels/types';

export const clearPropertyRelatedExpenses = (expenses: Expenses[]) => {
  const clearedPropertyExpenses = expenses.map((expense) => {
    return {
      ...expense,
      expenses: expense.expenses.map((expensesExpense) => {
        const isPropertyRelatedExpense = EXPENSE_PROPERTY_RELATED_EXPENSES.includes(expensesExpense.type);

        if (isPropertyRelatedExpense) {
          return { ...expensesExpense, amount: undefined };
        }
        return expensesExpense;
      }),
    };
  });
  return clearedPropertyExpenses;
};
